import LoadableContainer from '../LoadableContainer';

const LoadableEditor = LoadableContainer({
  loader: () => import('./components/ClientSideCodeEditor'),
});

export default LoadableEditor;
